import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css'; // Ensure Tailwind CSS is imported
import { AuthProvider } from '@/core/auth/auth-context';
import { disableConsoleLogs } from '@/shared/utils/disable-console-logs';
import { initSentry } from '@/utils/sentry';
import { reportWebVitals } from '@/utils/reportWebVitals';
import ErrorBoundary from '@/components/ErrorBoundary';

// Initialize Sentry error tracking
initSentry();

// Initialize Web Vitals performance tracking
reportWebVitals();

// Disable console logs in production environment
disableConsoleLogs();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
